import { Flex, Heading, Text } from '@applyboard/crystal-ui';

interface ThreeSixySolutionsHeadingProps {
  title: string;
  description: string;
}

function ThreeSixySolutionsHeading({ title, description }: ThreeSixySolutionsHeadingProps) {
  return (
    <Flex direction="column" gap={2}>
      <Heading level={2} intent="secondary" variant="titleL">
        {title}
      </Heading>
      <Text intent="secondary" variant="labelM" contrast="high">
        {description}
      </Text>
    </Flex>
  );
}

export default ThreeSixySolutionsHeading;
